import React, { useContext } from 'react'
import { func } from 'prop-types'
import styled from 'styled-components'

import { H2, H4, fontWeights, lineHeights } from 'styles/typography'
import { white } from 'styles/colors'
import * as spacing from 'styles/spacing'
import { media, mediaDown } from 'styles/media'

import NativeAuthContext from 'components/NativeAuth'
import Button from 'components/button/Button'

const Container = styled.div`
  text-align: center;
  padding: ${spacing.large};
  background-image: url('${process.env.BASE_PATH}/images/auth/burst.jpg');
  background-size: cover;
  background-position: center;

  ${media.small`
    padding: ${spacing.xLarge};
  `};

  ${media.medium`
    padding: ${spacing.xxLarge};
  `};

  ${media.large`
    padding: 56px;
  `};

  ${media.xLarge`
    padding: 72px;
  `};

  ${mediaDown.medium`
    margin-top: -${spacing.small};
  `};
`

const Heading = styled(H2)`
  color: ${white};
  font-family: 'Trim Poster';
  margin-bottom: ${spacing.medium};

  ${media.medium`
    margin-bottom: ${spacing.large};
  `};

  ${media.large`
    margin-bottom: ${spacing.xLarge};
  `};

  ${media.xLarge`
    margin-bottom: ${spacing.xxLarge};
  `};
`

const Subheading = styled(H4)`
  color: ${white};
  line-height: ${lineHeights.base};
  font-weight: ${fontWeights.regular};
  margin-bottom: 1.75em;
`

const Content = styled.div`
  padding: ${spacing.large};
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
  min-height: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${media.medium`
    min-height: 300px;
    max-width: 700px;
  `};
`

const WelcomeModal = ({ onButtonClick }) => {
  const { user } = useContext(NativeAuthContext)

  return (
    <Container>
      <Content>
        <Heading>Welcome to Vuse!</Heading>
        <Subheading>
          Thank you for creating your account {user?.firstName}. Discover vuse.com to see our products, offers and
          programs.
        </Subheading>
        <Button theme="custom" customColor={white} size="large" onClick={onButtonClick}>
          Shop now
        </Button>
      </Content>
    </Container>
  )
}

WelcomeModal.propTypes = {
  onButtonClick: func.isRequired
}

export default WelcomeModal
